import script from "./OOddilu.vue?vue&type=script&setup=true&lang=ts"
export * from "./OOddilu.vue?vue&type=script&setup=true&lang=ts"

import "./OOddilu.vue?vue&type=style&index=0&id=69a627df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a627df"]])

export default __exports__